import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

function EsqueciSenha() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setErro('');
    setCarregando(true);
    try {
      await api.post('/auth/esqueci-senha', { email });
      setEnviado(true);
    } catch (err) {
      setErro(err.response?.data?.mensagem || 'Erro ao processar solicitação.');
    }
    setCarregando(false);
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{ fontSize: 28, fontWeight: 800, color: '#1e40af', margin: 0 }}>CronoObra</h1>
          <p style={{ fontSize: 13, color: '#6b7280', marginTop: 6 }}>Recuperação de senha</p>
        </div>

        {enviado ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 16 }}>📧</div>
            <p style={{ fontSize: 14, color: '#374151', lineHeight: 1.6 }}>
              Se o e-mail estiver cadastrado, você receberá as instruções para redefinir sua senha em breve.
            </p>
            <button
              className="btn-secondary"
              style={{ marginTop: 24, width: '100%' }}
              onClick={() => navigate('/login')}
            >
              Voltar ao login
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 20 }}>
              Informe seu e-mail cadastrado e enviaremos um link para redefinir sua senha.
            </p>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>
              E-mail
            </label>
            <input
              type="email"
              placeholder="seu@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              style={{ marginBottom: 12 }}
              required
              autoFocus
            />
            {erro && (
              <div style={{
                background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8,
                padding: '10px 14px', fontSize: 13, color: '#dc2626', marginBottom: 12,
              }}>
                {erro}
              </div>
            )}
            <button
              className="btn-primary"
              type="submit"
              disabled={carregando}
              style={{ width: '100%', padding: '12px', fontSize: 15 }}
            >
              {carregando ? 'Enviando...' : 'Enviar link de recuperação'}
            </button>
            <button
              type="button"
              className="btn-secondary"
              style={{ width: '100%', marginTop: 10 }}
              onClick={() => navigate('/login')}
            >
              Voltar ao login
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default EsqueciSenha;
